import React, { useEffect, useState } from 'react'
import { Button, ConfigProvider, Form, Modal, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { FormButton } from '../group.styled'
import { useSelector } from 'react-redux'
import { fetchRoleList, modifyUserRole } from '../../../apis/role'

function EditUserModal (props) {
  const { show, setShow, data, successCallback = () => {}, adminMode } = props
  const { t: ln_t } = useTranslation()
  const [form] = Form.useForm()
  const user = useSelector((state) => state.user)
  const [isLoading, setIsLoading] = useState(false)
  const [roleOptions, setRoleOptions] = useState(false)

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`user.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`user.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const handleClose = () => {
    setShow(false)
    form.resetFields()
  }

  const handleSave = async value => {
    setIsLoading(true)
    const { groupUserRoleIds } = value || {}
    const params = adminMode ? { userId: data?.userId, groupId: data?.id } : { userId: data?.id, groupId: user?.nowGroup }
    const res = await modifyUserRole({ ...params, groupUserRoleIds })
    if (res?.status === 200) {
      successCallback(adminMode ? data?.userId : data?.id)
      handleClose()
    }
    setIsLoading(false)
  }

  const getRoleOptions = async groupId => {
    const res = await fetchRoleList({ groupId })
    if (res?.status === 200) setRoleOptions(res?.data?.map(i => ({ value: i.id, label: i.name })))
  }
  useEffect(() => {
    if (!show) return
    getRoleOptions(adminMode ? data?.id : user?.nowGroup)
    form.setFieldValue('groupUserRoleIds', data?.roles?.map(i => i.id))
  }, [show])

  return (
    <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
      <Modal title={`${ln_t('util.edit')} ${ln_t('user.user')}`} open={show} onCancel={handleClose} footer={null}>
        <Form form={form} layout="vertical" requiredMark={false} onFinish={e => handleSave(e)} style={{ marginTop: '16px' }}>
          <Form.Item {...defConfig('groupRole', 'select')} name="groupUserRoleIds">
            <Select showSearch mode="multiple" placeholder={defPlaceholder('groupRole', 'select')} options={roleOptions} optionFilterProp="children"/>
          </Form.Item>
          <FormButton>
            <Button type="default" onClick={handleClose}>{ln_t('util.cancel')}</Button>
            <Button type="primary" htmlType="submit" loading={isLoading}>{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
      </Modal>
    </ConfigProvider>
  )
}

export default EditUserModal
